import {Drawer, FormControl, FormControlLabel, Radio, RadioGroup, Stack} from "@mui/material";
import {useState} from "react";
import type {BasePlaces, ClosedOnDays} from "../../firebase/index.js";
import {addPlace, PlaceModel, TripModel} from "../../firebase/index.js";
import {useInMemoryTrip} from "../../redux/InMemoryTripReducer.js";
import APXActionButtons from "../../reusables/APXActionButtons.jsx";
import type {BSLProps} from "../../reusables/js/APXBottomSheetLayoutUtils.js";
import useBottomSheet from "../../reusables/js/APXBottomSheetLayoutUtils.js";
import type {ItinerarySummaryLayoutProps} from "./ItinerarySummaryLayout.jsx";


export default function SummaryAnchorSelectorBSL({uid, onClose, dateKey, basePlaces}: BSLProps & ItinerarySummaryLayoutProps) {
	  
	  const [selectedDateMillis, setSelectedDateMillis] = useState(0);
	  
	  const inMemoryTrip: TripModel = useInMemoryTrip();
	  
	  const {isOpen, handleOpen, handleClose} = useBottomSheet({initialState: true, onClose});
	  
	  
	  const handleCancel = () => {
			 onClose();
	  };
	  
	  const handleAdd = () => {
			 if (/*FALSY->*/ !!!uid) {
					alert("Please login to change the anchor");
					return;
			 }
			 if (/*FALSY->*/ !!!selectedDateMillis) {
					alert("Please select a date as anchor");
					return;
			 }
			 if (Object.keys(inMemoryTrip.tripDates).length === 0) {
					alert("Trip dates are not set yet");
					return;
			 }
			 
			 Object.values(basePlaces).forEach((place: PlaceModel) => {
					place.setAnchoredOnDate(selectedDateMillis);
					if (place.isTransport) place.closedOnDays = {};
					addPlace(uid, inMemoryTrip.itineraryKey, Number(dateKey), place.placeKey, null);
					addPlace(uid, inMemoryTrip.itineraryKey, selectedDateMillis, place.placeKey, place);
			 });
			 
			 handleCancel();
	  };
	  
	  return (
				 <>
						<Drawer anchor="bottom" open={isOpen} onClose={handleClose} variant="temporary">
							  <Stack spacing={2} p={2}>
									 <FormControl>
											<RadioGroup value={selectedDateMillis}
															onChange={(event) => setSelectedDateMillis(Number(event.target.value))}
											>
												  {
															 Object.keys(inMemoryTrip.tripDates).length > 0
															 && Object.keys(inMemoryTrip.tripDates).map((dateMillis) => {
																	return (
																			  <FormControlLabel
																						 key={dateMillis}
																						 control={<Radio/>}
																						 label={new Date(Number(dateMillis)).toLocaleDateString("en-GB", {weekday: "short", day: "numeric", month: "short"})}
																						 value={Number(dateMillis)}
																						 disabled={doDisablingLogic(dateMillis, basePlaces)}
																			  />
																	);
															 })
												  }
											</RadioGroup>
									 </FormControl>
									 <APXActionButtons onCancel={handleCancel} onAdd={handleAdd}/>
							  </Stack>
						</Drawer>
				 </>
	  );
}


function doDisablingLogic(m: string, bp: BasePlaces): boolean {
	  const obj: ClosedOnDays = {}; /* DDD string : closed boolean */
	  Object.entries(bp).forEach(([key, p]) => {
			 if (/*TRUTHY->*/!!p.closedOnDays) {
					Object.entries(p.closedOnDays).filter(([key, value]) => value).forEach(([key, value]) => obj[key] = value);
			 }
			 if (/*TRUTHY->*/ !!p.anchoredOnDate) {
					const DDD = new Date(Number(p.anchoredOnDate)).toLocaleDateString("en-GB", {weekday: "short"}).toUpperCase();
					obj[DDD] = true;
			 }
	  });
	  const mDDD = new Date(Number(m)).toLocaleDateString("en-GB", {weekday: "short"}).toUpperCase().toUpperCase();
	  return Object.hasOwn(obj, mDDD);
}